import Image from '@components/Image';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import dayjs from 'dayjs';
import {
    Dispatch, SetStateAction, useMemo,
} from 'react';
import { useTranslation } from 'react-i18next';

import DefaultCheckedIcon from './DefaultCheckedIcon';

interface Props {
    value: number;
    stampCount: number;
    expireIndex: number;
    setExpireIndex: Dispatch<SetStateAction<number>>;
    stampExpireDay?: string;
}

function StampIcon({
    value, stampCount, setExpireIndex, expireIndex, stampExpireDay,
}:Props) {
    const { t } = useTranslation('stamp');
    const { stampImage, stampDefaultImage } = useAppCustom().membership;
    const isActive = value < stampCount;
    const leftDays = stampExpireDay ? dayjs(stampExpireDay)
        .diff(dayjs().set('hour', 0).set('minute', 0).set('second', 0), 'days') + 1 : undefined;
    const stampIcon = useMemo(() => {
        if (isActive) {
            if (stampImage) {
                return (
                    <CircleImage width='100%'
                        src={stampImage}/>
                );
            }
            return (<DefaultCheckedIcon/>);
        }
        if (stampDefaultImage) {
            return (
                <CircleImage width='100%' src={stampDefaultImage}/>
            );
        }
        return <DefaultStamp />;
    }, [stampDefaultImage, stampImage, isActive]);
    return (
        <Wrapper onClick={() => setExpireIndex(value)}>
            {stampIcon}
            {(expireIndex === value && value < stampCount) && (
                <ExpiredWrapper>
                    <Text size='body-long'
                        fontWeight='bold'
                        color={colors.white}>
                        {leftDays}{t('card.daysUnit')}
                    </Text>
                </ExpiredWrapper>
            )}
        </Wrapper>
    );
}

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    position: relative;
    width: 100%;
`;

const CircleImage = styled(Image)`
    border-radius: 50%;
    aspect-ratio: 1;
`;

const DefaultStamp = styled.div<{
    isChecked?: boolean;
}>`
    aspect-ratio: 1;
    background-color: ${({ isChecked }) => (isChecked
        ? 'var(--color-primary)' : 'var(--color-gray1)')} ;
    border-radius: 50%;
    width: 100%;
    border:  ${({ isChecked }) => (isChecked
        ? '2px solid var(--color-white)' : 'none')};
`;

const ExpiredWrapper = styled.div`
    background-color: var(--color-gray9);
    padding: 0 6px;
    position: absolute;
    transform: translateX(19px) translateY(-6px);
`;

export default StampIcon;
